import { msalInstance } from './msal.instance';

export default {
  install(app) {
    app.config.globalProperties.$msal = msalInstance;
  }
};